/* Connect TempLoginForm to the Backend */
import { connect } from 'react-redux';
import TempLoginForm from './TempLoginForm';
import CAC from './Constants';
import * as tempactions from './Actions';




const mapStateToProps = state => ({
    tickle: state.tickle,
    userlist: state.userlist,
    sendlist: state.sendlist,
    messageStatus: state.messageStatus,
});

const mapDispatchToProps = dispatch => ({
    pwGetUserlist: () => {
        dispatch(tempactions.pwGetUserlist()).then((response) => {
         !response.error ? 
         dispatch(tempactions.pwGetUserlistSuccess(response.value.data)) :
         dispatch(tempactions.pwGetUserlistFailure(response.value.data))
        });
     },
     pwGetSendlist: () => {
        dispatch(tempactions.pwGetSendlist()).then((response) => {
         !response.error ? 
         dispatch(tempactions.pwGetSendlistSuccess(response.value.data)) :
         dispatch(tempactions.pwGetSendlistFailure(response.value.data))
        });
     },        
     setMessageStatus: (newMessage) => {
        dispatch(tempactions.pwUpdateMessageStatus(newMessage));
    },
     tickle: () => {
        dispatch({
        type: `${CAC.TICKLE}`,
      })
    }
});

const TempLoginFormConnectContainer =  connect(mapStateToProps, mapDispatchToProps)(TempLoginForm);

export default TempLoginFormConnectContainer;



// WEBPACK FOOTER //
// ./src/TempLoginFormConnectContainer.js